/**
 * Format a millisecond duration as "MM:SS". Clamps negative values to 0.
 * Matches the backend leaderboard formula so displayed totals add up.
 */
export function formatMmSs(ms: number): string {
  const totalSec = Math.floor(Math.max(0, ms) / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

/**
 * Split a player's totalTimeMs (which already includes penaltyMs) into the
 * base-time + penalty breakdown shown on the results screen. Clamps both
 * components to be non-negative. Returns `totalMs` unchanged as a convenience
 * so callers can pass the whole triple to a formatter.
 */
export function computeBreakdown(
  totalMs: number,
  penaltyMs: number
): { baseMs: number; penaltyMs: number; totalMs: number } {
  const clampedPenalty = Math.max(0, penaltyMs || 0);
  const clampedTotal = Math.max(0, totalMs || 0);
  const baseMs = Math.max(0, clampedTotal - clampedPenalty);
  return { baseMs, penaltyMs: clampedPenalty, totalMs: clampedTotal };
}
